import { getFilterParamObject } from './getFilterParamObject';
import { getItemsParamArray } from './getItemsParamArray';
import { getItemsQueryString } from './getItemsQueryString';
import { getLimitQueryString } from './getLimitQueryString';
import { getOffsetQueryString } from './getOffsetQueryString';
import { getSortParamArray } from './getSortParamArray';
import { getSortQueryString } from './getSortQueryString';
import { getUrlParamsStringFromArray } from './getUrlParamsStringFromArray';
import { stringifyBracketParameter } from './stringifyBracketParameter';

export const getDataParamsString = (
  activeFilters: Record<string, any> | null,
  activeSorting: { field: string; order: number }[],
  dataset: any,
  limit?: number,
  offset?: number,
  // Override items list — control-action prefetch passes a minimal
  // [idItem, labelItem] set to avoid fetching every visible column.
  itemsOverride?: string[],
  // Already request-shaped filter merged on top of the converted activeFilters,
  // taking precedence. Used for locked filters (e.g. a reference's default
  // filter) whose nested shape (or/and arrays) getFilterParamObject would mangle.
  additionalFilterObject?: Record<string, any>
) => {
  const urlParams: string[] = [];
  // Items param
  const items = itemsOverride ?? getItemsParamArray(dataset);
  const itemsQuery = getItemsQueryString(items);

  if (itemsQuery) {
    urlParams.push(itemsQuery);
  }

  // Sort param
  const sortParamArray = getSortParamArray(activeSorting);
  const sortQuery = getSortQueryString(sortParamArray);

  if (sortQuery) {
    urlParams.push(sortQuery);
  }

  // Filter param: convert the user's activeFilters, then merge the already
  // request-shaped additionalFilterObject on top so it always applies.
  const filtersObject = {
    ...getFilterParamObject(activeFilters),
    ...(additionalFilterObject ?? {}),
  };
  // Convert filter object to OpenAPI string for GET params
  const filterString = stringifyBracketParameter({ filter: filtersObject });
  if (filterString) {
    urlParams.push(filterString);
  }

  if (limit) {
    urlParams.push(getLimitQueryString(limit));
  }

  if (offset) {
    urlParams.push(getOffsetQueryString(offset));
  }

  return getUrlParamsStringFromArray(urlParams);
};
